module.exports = __webpack_public_path__ + "img/boxx-mini-black.e34b9102.svg";